// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"Iter_boxContainer__1wQdO"};